﻿// Corresponds to ChangeAgendaDto.cs
export interface ChangeSedcardDto {
    // Remark: Names are upper-case on purpose in order to match the C# DTO
   
    Name: string;
    CardType: SedcardType;
    Title: string;
    Company: string;
    SpeakerImage: string;
    SpeakerImageChanged: any;
    Logo: string;
    LogoChanged: any; // IFormFile
    Telephone: string;
    Email: string;
    Website: string;
    Address: string;
    Description: string;
    Background: string;
    FontColor: string;
    MeetName: string;
    MeetDescription: string
    MeetWelcomeMessage: string;
    MeetWelcomeMessageModerator: string;
    MeetBackgroundColor: string;
    MeetLogoutUrl: string;
    MeetLogoId: string;
    MeetLogoChanged: any;
    MeetJoinImageId: string;
    MeetJoinImageChanged: any;
    MeetPresentationId: string;
    MeetPresentationChanged: any;
    LinkedInProfile: string;
    PlayerHeader: string;
    PlayerContent: string;
}

export enum SedcardType {
    Speaker = 0,
    Sponsor = 1
}